
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[slug]/[child]",
      function () {
        return require("private-next-pages/[slug]/[child].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[slug]/[child]"])
      });
    }
  